import * as React from 'react';

import { ScrollableSlider } from '../../components/ScrollableSlider';
import { useSlideClick } from './hooks';

export interface IScrollableSliderContainerProps<TItem> {
  slides: TItem[];
  renderSlide(item: TItem, index: number): React.ReactNode;
  visibleSlides?: number;
}

export function ScrollableSliderContainer<TItem>({
  slides,
  renderSlide,
  visibleSlides = 1,
}: IScrollableSliderContainerProps<TItem>) {
  const { onSlideMouseDown, onSlideClickCapture } = useSlideClick();

  const renderedItems = slides.map((slide, index) => renderSlide(slide, index));

  return (
    <ScrollableSlider
      slides={renderedItems}
      onSlideMouseDown={onSlideMouseDown}
      onSlideClickCapture={onSlideClickCapture}
      visibleSlides={visibleSlides}
    />
  );
}
